import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { AnalysisTriggerRuleTypeDto } from '@/models/analysis-triggers/AnalysisTriggerRuleTypeDto';

export class AnalysisTriggerRuleTypeService {
  private readonly client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/AnalysisTriggerRuleTypes');
  }

  async list(): Promise<AnalysisTriggerRuleTypeDto[]> {
    return await this.client.get<AnalysisTriggerRuleTypeDto[]>('');
  }
}
